module.exports = __webpack_public_path__ + "9d368c424011dbe1859800242f6bbb28.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GB-ENG.svg
// module id = GEyK
// module chunks = 0